module.exports = __webpack_public_path__ + "7b1d1d3560919360206da7cab27aaf58.webm";